import { ApiStatus } from '../../types';

export const mainIncomeValidate = {
    'hardValidations': {
        taxSelector: {
            defaultErrorMessage: '{Select either before or after tax validation required placeholder}',
        },
        amount: {
            minValue: 0.01,
            minValueMessage: '{income amount is too low}',
            defaultErrorMessage: '{Enter amount validation required placeholder}',
            negativeValueMessage: '{Amount must be positive}',
        },
        frequency: {
            defaultErrorMessage: '{Select frequency validation required placeholder}',
        },
    },
};
export const mainIncomeDefaultAEM = {
    heading: '{heading placeholder}',
    description:
        '{description placeholder}',
    incomeAmountLabel: '{Amount}',
    incomeAmountPlaceholder: '{$}',
    incomeFrequencyDropdownLabel: '{Frequency}',
    confirmButtonText: '{confirmButtonText}',
    cancelButtonText: '{cancelButtonText}',
    incomeTaxRadioButtonText: [
        {
            'key': 'Before tax',
            'value': 'Before tax',
        },
        {
            'key': 'After tax',
            'value': 'After tax',
        },
    ],
    validations: mainIncomeValidate,
    frequency: [
        {
            'key': 'Weekly',
            'value': 'Weekly',
        },
        {
            'key': 'Fortnightly',
            'value': 'Fortnightly',
        },
        {
            'key': 'Monthly',
            'value': 'Monthly',
        },
    ],
};

export type MainIncomeDefaultContent = typeof mainIncomeDefaultAEM;

export type MainIncomeValidate = typeof mainIncomeValidate;

export interface MainIncomeDetail {
    incomeId: number
    taxSelector: string
    frequency: string
    amount: number;
}

export interface FetchMainIncomePayload {
    incomeId: number
    taxSelector: string
    frequency: string
    amount: number
    content: string,
}

export interface MainIncomeErrorMessage {
    incomeType?: string
    taxSelector?: string
    frequency?: string
    amount?: string
    description?: string
    netAmount?: string | null
}

export interface MainIncomeEndpoints {
    getMainIncomeUrl: string;
    upsertMainIncomeUrl?: string;
}

export interface MainIncomeState {
    incomeDetails: MainIncomeDetail;
    apiStatus: ApiStatus;
    content: MainIncomeDefaultContent;
    apiEndpoints: MainIncomeEndpoints;
}

